import React from 'react';
import { useNavigate } from 'react-router-dom';
import { object, string } from 'yup';

import { useToast } from 'Component/Alerta';
import BotaoLink from 'Component/BotaoLink';
import Cabecalho from 'Component/Cabecalho';
import Form, { Botao, CaixaDeTexto, Campo, Selecao } from 'Component/Form';
import LayoutDefault from 'Component/Layout';
import Treinamento from 'Interface/Treinamentos';
import { useRecuperarDepartamentosQuery } from 'View/Service/Default/Departamentos';
import { useAdicionarTreinamentoMutation } from 'View/Service/Default/Treinamentos';

const regras = object({
  titulo: string().required('Obrigatório'),
  departamento_id: string().required('Obrigatório'),
  descricao: string().nullable().optional(),
});

const Adicionar = (): React.ReactElement => {
  const navegacao = useNavigate();
  const toast = useToast();
  const [adicionarTreinamento] = useAdicionarTreinamentoMutation();

  const { data: { departamentos } = {} } = useRecuperarDepartamentosQuery({
    finder: 'listaJson',
    sort: 'nome',
    limit: 200,
  });

  const enviar = async (dados: Treinamento): Promise<void> => {
    try {
      const resposta = await adicionarTreinamento(dados).unwrap();

      toast({ conteudo: 'Adicionado com sucesso!', tema: 'success' });

      navegacao(`/treinamentos/editar/${resposta.treinamento.id}`);
    } catch (error) {
      toast({
        titulo: 'Erro ao adicionar',
        conteudo: 'Verifique os logs para maiores detalhes.',
        tema: 'danger',
      });
    }
  };

  return (
    <LayoutDefault>
      <Cabecalho
        titulo="Adicionando treinamento"
        descricao="Preencha o formulário e clique em enviar para adicionar o treinamento"
      />
      <Form onSubmit={enviar} regras={regras}>
        <div className="row justify-content-center">
          <div className="col-md-8">
            <div className="bg-white shadow-sm rounded p-4">
              <div className="row">
                <div className="col-md-8">
                  <Campo name="titulo" rotulo="Título" />
                </div>
                <div className="col-md-4">
                  <Selecao
                    name="departamento_id"
                    rotulo="Departamento"
                    opcoes={departamentos}
                  />
                </div>
              </div>
              <CaixaDeTexto name="descricao" rotulo="Descrição" />
              <div className="mt-5">
                <Botao>Enviar</Botao>
                <BotaoLink tema="light" to="/treinamentos" className="ms-2">
                  Cancelar
                </BotaoLink>
              </div>
            </div>
          </div>
        </div>
      </Form>
    </LayoutDefault>
  );
};

export default Adicionar;
